import Vue from 'vue'
import dotenv from 'dotenv'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueAxios from 'vue-axios'
import VueApexCharts from 'vue-apexcharts'
import VueCookies from 'vue-cookies'
import VueSession from 'vue-session'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VueSweetalert2  from 'vue-sweetalert2';
//import VueSwal from 'vue-swal'
import VueSingleSelect from "vue-single-select";
import vSelect from "vue-select";
import StarRating from 'vue-star-rating'
import moment from 'moment'
import BootstrapVue from 'bootstrap-vue'
import VueSlider from 'vue-slider-component'
import Vuesax from 'vuesax'
import Vuetify from 'vuetify'
import JsonCSV from 'vue-json-csv'
import JsonExcel from 'vue-json-excel'
import Tooltip from 'vue-directive-tooltip'
import Multiselect from 'vue-multiselect'
import LoadScript from "vue-plugin-load-script"
import * as Sentry from "@sentry/vue"

import api from '@/services/api'
import router from '@/router/router'
import store from '@/store/store'
import App from '@/App.vue'

import { Map, TileLayer, OsmSource, Geoloc } from 'vuelayers'
import { VueHammer } from 'vue2-hammer'
import { IconsPlugin } from "bootstrap-vue"

import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-slider-component/theme/default.css'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import '../themeConfig.js'
import '@/globalComponents.js'
import '@/assets/scss/main.scss'
import '@/filters/filters'
import '@/assets/css/vuelayers.css' // needs css-loader
import '@/assets/css/main.css'

require('./assets/css/iconfont.css')

dotenv.config()

Vue.use(BootstrapVue)
Vue.use(Geoloc)
Vue.use(IconsPlugin)
Vue.use(LoadScript)
Vue.use(Map)
Vue.use(money, { precision: 4 })
Vue.use(Multiselect)
Vue.use(OsmSource)
Vue.use(StarRating)
Vue.use(TileLayer)
Vue.use(Tooltip)
Vue.use(VueApexCharts)
Vue.use(VueAxios, api)
Vue.use(VueCookies)
Vue.use(VueHammer)
Vue.use(Vuesax)
Vue.use(VueSession, { persist: true })
Vue.use(VueSingleSelect)
Vue.use(VueSweetalert2)
Vue.use(VueTheMask)
Vue.use(Vuetify)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAdwxi7P7SUDsbcxa3RRcQ315FDIOh1log', //minha chave
   // key: 'AIzaSyBJeiw9cv7HAzJqLYAuMXwh5f-R9kiJxr0', //chave filoo
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
})

Vue.component('vue-single-select', VueSingleSelect)
Vue.component("v-select", vSelect)
Vue.component('star-rating', StarRating)
Vue.component('VueSlider', VueSlider)
Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)
Vue.component('downloadExcel', JsonExcel)
Vue.component('multiselect', Multiselect)

Vue.loadScript("https://js.iugu.com/v2")
  .then((data) => {
    // Script is loaded, do something
    console.log("Script is loaded Iugu, do something", data)
  })
  .catch(() => {
    // Failed to fetch script
    console.log("erro Iugu");
  });

if (process.env.VUE_APP_SENTRY_DSN_URL) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN_URL,
    tracesSampleRate: 1.0
  })
}  

Vue.prototype.moment = moment
Vue.config.productionTip = false
VueCookies.config('2d')

new Vue({
  router,
  components: { App },
  store,
  beforeCreate() { this.$store.commit('INITIAL_STORE');},
  render: h => h(App)
}).$mount('#app')
